module.exports = __webpack_public_path__ + "img/logo04.e0308d46.png";